/** Recursively resolve default values for all ticket mode fields and their nested children */
export function getDefaultTicketModes(ticketModes: Array<App.TicketModeField>): Record<string, string> {
  let result: Record<string, string> = {}

  ticketModes.forEach(mode => {
    if (mode.default) {
      result[mode.key] = mode.default

      mode.options.forEach(option => {
        if (option.key === mode.default && option.fields) {
          result = { ...result, ...getDefaultTicketModes(option.fields) }
        }
      })
    }
  })

  return result
}
